import { TimeEntrySetting } from 'components/molecules/tasks/details/time-entry-settings';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacTimeEntrySettingTitle = withAccess(TimeEntrySetting.Title);
export const RbacTimeEntrySettingList = withAccess(TimeEntrySetting.List);
